const meta = { requiresAuth: true };

const Reports = () => import(/* webpackChunkName: "reports" */ '@/views/reports/Root');
const ReportsReviews = () => import(/* webpackChunkName: "reports-reviews" */ '@/views/reports/reviews/Root');
const ReportsReviewsSummary = () => import(/* webpackChunkName: "reports-reviews-summary" */ '@/views/reports/reviews/Summary');
const ReportsReviewsDetail = () => import(/* webpackChunkName: "reports-reviews-detail" */ '@/views/reports/reviews/Detail');
const ReportsGoal = () => import(/* webpackChunkName: "reports-goals" */ '@/views/reports/goals/Root');
const ReportsGoalSummary = () => import(/* webpackChunkName: "reports-goals-summary" */ '@/views/reports/goals/Summary');
const ReportsGoalDetail = () => import(/* webpackChunkName: "reports-goals-detail" */ '@/views/reports/goals/Detail');
const ReportsNineBoxRoot = () => import(/* webpackChunkName: "reports-nine-box" */ '@/views/reports/nine-box/Root');
const ReportsNineBoxGenerate = () => import(/* webpackChunkName: "reports-nine-box-generate" */ '@/views/reports/nine-box/generate/Index');
const ReportsNineBoxResultIndex = () => import(/* webpackChunkName: "reports-nine-box-result-index" */ '@/views/reports/nine-box/result/Index');
const ReportsNineBoxResultDetail = () => import(/* webpackChunkName: "reports-nine-box-result-detail" */ '@/views/reports/nine-box/result/Detail');

export default [
  {
    path: '/reports',
    component: Reports,
    children: [
      {
        path: '',
        name: 'reports_index',
        beforeEnter: (to, from, next) => {
          const userProfile = JSON.parse(localStorage.userProfile);
          const isSuperAdmin = userProfile.isa;
          const hasAccessReviewReport = userProfile.prm.indexOf('review-cycle.report') !== -1;
          if (isSuperAdmin || hasAccessReviewReport) {
            next({ name: 'review_cycle_report_summary' });
          } else {
            next({ name: 'goals_report_summary' });
          }
        },
      },

      // Reviews
      {
        path: 'reviews',
        meta,
        component: ReportsReviews,
        children: [
          {
            path: 'summary',
            name: 'review_cycle_report_summary',
            component: ReportsReviewsSummary,
          },
          {
            path: 'detail',
            name: 'review_cycle_report_detail',
            component: ReportsReviewsDetail,
          },
          {
            path: '',
            name: 'reviews_report',
            redirect: 'summary',
          },
        ],
      },

      // Goals
      {
        path: 'goals',
        component: ReportsGoal,
        children: [
          {
            path: '',
            redirect: 'summary',
          },
          {
            path: 'summary',
            name: 'goals_report_summary',
            meta,
            component: ReportsGoalSummary,
          },
          {
            path: 'details',
            name: 'goals_report_detail',
            meta,
            component: ReportsGoalDetail,
          },
        ],
      },

      // 9 box
      {
        path: 'nine-box',
        name: 'nine-box',
        component: ReportsNineBoxRoot,
        children: [
          {
            path: '',
            redirect: 'generate',
          },
          {
            path: 'generate',
            name: 'nine-box_generate',
            component: ReportsNineBoxGenerate,
            meta,
          },
          {
            path: 'result',
            name: 'nine-box_result',
            component: ReportsNineBoxResultIndex,
            meta,
          },
          {
            path: 'result/:id',
            name: 'nine-box_result_detail',
            component: ReportsNineBoxResultDetail,
            meta,
          },
        ],
      },
    ],
  },
];
